import React, { FC } from 'react';


const ScheduleDemoEclinic: FC = () => <section className='schedule-demo-container'>
                                            <h2>Hola, Necesitas un demo?</h2>
                                       </section>;
                                       
export default ScheduleDemoEclinic;                                       